<template>
  <div>
    <b-row>
      <!-- Search -->
      <b-col
        cols="12"
        class="mt-2 mb-4"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="searchValue"
            class="d-inline-block mr-1"
            placeholder="Filtrar..."
            @keyup="filtro($event, 'title', filterGlobal)"
          />
        </div>
      </b-col>
    </b-row>

    <b-row>
      <div
        v-for="(item) in lives_filtred"
        :key="item.id"
        style="margin: 5px;"
      >
        <a :href="`/podcasts/${item.slug}/`">
          <b-card
            :title="item.title"
            img-alt="Image"
            :img-src="`${path}/storage/live/image/${item.img}`"
            img-top
            tag="article"
            md="4"
            style="max-width: 20rem;display:block;"
          />
        </a>
      </div>
      <b-modal
        id="listModal"
        ref="listModal"
        v-model="modalShow"
        hide-footer
        title="Lista de streams"
        ok-only
        ok-title="Accept"
      >
        <b-card-text>
          <b-button
            v-if="modalData.deezer == 'null'"
            :href="`https://deezer.page.link/${modalData.deezer}/`"
            variant="outline-primary"
            block
          >
            <span>
              Deezer
            </span>
          </b-button>
          <b-button
            :href="`https://podcasts.google.com/feed/${modalData.doogle_podcast}/`"
            variant="outline-primary"
            block
          >
            <span>
              Google podcast
            </span>
          </b-button>
          <b-button
            :href="`https://open.spotify.com/episode/${modalData.spotify}/`"
            variant="outline-primary"
            block
          >
            <span>
              Spotify
            </span>
          </b-button>
          <b-button
            :href="`https://pca.st/${modalData.pca}/`"
            variant="outline-primary"
            block
          >
            <span>
              Pocketcasts
            </span>
          </b-button>
          <b-button
            :href="`https://castro.fm/podcast/${modalData.castro}/`"
            variant="outline-primary"
            block
          >
            <span>
              Castro
            </span>
          </b-button>
          <b-button
            :href="`https://podcasts.apple.com/br/podcast/podcast-sbg-papers/${modalData.apple_podcast}/`"
            variant="outline-primary"
            block
          >
            <span>
              Apple podcast
            </span>
          </b-button>
          <b-button
            :href="`https://overcast.fm/${modalData.overcast}/`"
            variant="outline-primary"
            block
          >
            <span>
              Overcast
            </span>
          </b-button>
          <b-button
            :href="`https://www.youtube.com/watch?v=${modalData.youtube}/`"
            variant="outline-primary"
            block
          >
            <span>
              Youtube
            </span>
          </b-button>
          <b-button
            :href="`https://soundcloud.com/sbglaucoma/${modalData.soundcloud}/`"
            variant="outline-primary"
            block
          >
            <span>
              Soundcloud
            </span>
          </b-button>
        </b-card-text>
      </b-modal>
      <b-modal
        id="evt-modal-notification"
        size="lg"
        title="Eventos para hoje"
        ok-only
        no-stacking
      >
        <div>
          Você pode ter eventos para hoje:
          <ul
            id="notification"
            style="overflow-y: scroll;height:220px;"
          >
            <li
              v-for="l in liveList"
              :key="l.id"
            >
              {{ l.live.title }}

              <b-button
                variant="info"
                :href="`/lives/${l.live.link}/${l.live.frame.id}`"
              >
                Entrar ao vivo
              </b-button>
            </li>
          </ul>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import LivesServices from './LivesServices'

export default {
  data() {
    return {
      lives: [],
      lives_filtred: [],
      path: '',
      modalShow: false,
      modalData: [],
      disabled: [],
      liveList: [],
      modalListPodcast: [],
      searchValue: null,
    }
  },
  mounted() {
    this.path = process.env.VUE_APP_API_BASE
    LivesServices().getLives().then(api => {
      this.lives = api.data.response.podcasts
      this.lives_filtred = this.lives
    })
    setInterval(() => {
      this.isReady()
    }, 10000)

    // get Lives for users
    LivesServices().getLiveSpeakerBySpeaker().then(api => {
      this.liveList = api.data.response.liveSpeaker
      if (this.liveList.length > 0) { this.$bvModal.show('evt-modal-notification') }
    })
  },
  methods: {
    filtro(e, propriedadePesquisa, filterGlobal) {
      if (e.target.value.trim() !== '') {
        const lista = this.lives
        const result = filterGlobal(e, lista, propriedadePesquisa)
        this.lives_filtred = result
      } else {
        this.lives_filtred = this.lives
      }
    },
    isReady() {
      LivesServices().getLives().then(api => {
        this.lives = api.data.response.podcasts
      })
    },
    openModal(data) {
      this.modalData = data
      this.modalShow = true
    }
  }
}
</script>

<style>

</style>
